import {
  Component,
  ViewEncapsulation,
  ViewChild, OnInit
} from '@angular/core';

import { ColabsTableComponent } from './colabs-table/colabs-table.component';
import { ColabsModalChangeGroupComponent } from './colabs-modal-change-group/colabs-modal-change-group.component';
import { UserService } from '../../../../services/user.service';
import * as moment from 'moment/moment';
import {CostCenterService} from '../../../../services/cost-center.service';

@Component({
  selector: 'app-colabs-listing',
  templateUrl: './colabs-listing.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [UserService, CostCenterService]
})

export class ColabsListingComponent implements OnInit {

  public isActionButtonsBlocked = true;
  public rowsCount = 0;
  public employeesUninvited = 0;
  public employeesInactive = 0;
  public haveEmailSelected = false;
  public costCenters: any;

  @ViewChild('modalChangeAccountGroup') public colabsModalChangeGroup: ColabsModalChangeGroupComponent;
  @ViewChild(ColabsTableComponent) public colabsTable: ColabsTableComponent;

  constructor(private userService: UserService, private costCenterService: CostCenterService) {}

  ngOnInit() {
    this.userService.requestAccountConfig();
    this.loadCostCenters();
  }

  public loadCostCenters(): void {
    const loggedAccount = this.userService.getLoggedAccount();
    const typeBusiness = this.userService.getTypeAccount();

    if (typeBusiness === 'company') {
      const companyId = loggedAccount.id;
      const params = [
        { param: 'companyId', value: companyId, },
        { param: 'limit', value: 0 },
        { param: 'skip', value: 0 }
      ];

      this.costCenterService.getCostCenters(params).then(res => {
        const { data } = res;
        this.costCenters = data;
      });
    }
  }

  canSendEmails() {
    const loggedAccount = this.userService.getLoggedAccount();
    const lastSentDate = loggedAccount ? loggedAccount.invitesLastSentDate : null;

    if (lastSentDate) {
      const dataToCompare = moment().add({hours: -3}).format();
      return moment(dataToCompare).isAfter(lastSentDate);
    } else {
      return true;
    }
  }

  public haveEmployeesWithEmailSelected($event: boolean) {
    this.haveEmailSelected = $event;
  }

  public setRowsCount($event: number): void {
    this.rowsCount = $event;
  }

  public setCountUnivited($event): void {
    this.employeesUninvited = $event.length;
  }

  public setCountInactive($event): void {
    this.employeesInactive = $event.length;
  }

  public fetchRows($event): void {
    if (!$event.isSimpleSearch) {
      this.colabsTable.fetchRowsAdvancedSearch($event);
    } else {
      this.colabsTable.fetchRows($event);
    }
  }

  public sendInvitationToSelected($event): void {
    if ($event) {
      this.colabsTable.sendInvitation('sendInvitationToAll');
    } else {
      this.colabsTable.sendInvitationToSelected();
      this.haveEmailSelected = false;
    }
  }

  public unlockSelected(): void {
    this.colabsTable.unlockSelected();
  }

  public blockSelected(): void {
    this.colabsTable.blockSelected();
  }

  public sendInvitationToUninvited(): void {
    this.colabsTable.sendInvitation('sendInvitationToUninvited');
  }

  public sendInvitationAgain(): void {
    this.colabsTable.sendInvitationAgain();
  }

  public onUnblockButtons(event): void {
    this.isActionButtonsBlocked = !event;
  }

  saveChange(costCenterId) {
    this.colabsTable.saveAccountsGroup(costCenterId);
  }

  openGroupModal() {
    this.colabsModalChangeGroup.openModal();
  }

  closeGroupModal() {
    this.colabsModalChangeGroup.closeModal();
  }
}
